import { syncPhoneValidator } from 'signup-ui-lego-core/test/spec/validation/phoneValidator';
import { getFlowSpecificErrorMessage } from '../../../utils/getFlowSpecificErrorMessage';
const getErrorMessage = (_value, error, dataKey) => {
  return getFlowSpecificErrorMessage(dataKey, error);
};
export const phoneNumberValidator = {
  sync: syncPhoneValidator,
  getErrorMessage
};